module.exports = __webpack_public_path__ + "img/velans-ff-2.7219eeb.jpg";